/*
 * Enclosure protection-class labels. Mirrors Mobilproses/Constants/ProtectionClass.cs -
 * keep the two in step.
 *
 * The label was renamed from IP31 to IP41. The numeric value used for the PanelHeatFactors
 * lookup is unchanged (31 / 55): this is a naming change only and must not move any
 * calculated number.
 *
 * The legacy label is still accepted because it survives in two places we do not control
 * at deploy time: rows written to Projects.IP before the migration, and the Vuex "panelIP"
 * key persisted in a returning user's localStorage.
 */
export const AT_OR_BELOW = '≤IP41';
export const ABOVE = '>IP41';

export const LEGACY_AT_OR_BELOW = '≤IP31';
export const LEGACY_ABOVE = '>IP31';

/** True when the enclosure is at or below the lower class, in either spelling. */
export function isAtOrBelow(ip) {
	return ip === AT_OR_BELOW || ip === LEGACY_AT_OR_BELOW;
}

/**
 * The IPStandart value used to look up PanelHeatFactors. Unchanged by the rename.
 * Anything that is not the lower class - including an empty label - resolves to 55,
 * which is what the previous code returned for an empty or ">IP31" label.
 */
export function toIpStandart(ip) {
	return isAtOrBelow(ip) ? 31 : 55;
}

export default { AT_OR_BELOW, ABOVE, LEGACY_AT_OR_BELOW, LEGACY_ABOVE, isAtOrBelow, toIpStandart };
